import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ConsigmentSwitcherState {
  currentArticleIndex: number;
}
export const initialState: ConsigmentSwitcherState = {
  currentArticleIndex: 0,
};

export const consignmentSwitcherSlice = createSlice({
  name: 'consignmentSwitcher',
  initialState,
  reducers: {
    setCurrentArticleIndex: (state, action: PayloadAction<number>) => {
      state.currentArticleIndex = action.payload;
    },
  },
});

export const { setCurrentArticleIndex } = consignmentSwitcherSlice.actions;
